import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { NewsService } from '../../shared/services/news.service';
import { LanguageService } from '../../shared/services/language.service';

declare var $:any
import {isBrowser} from '../../shared/thirdparty/isBrowser'

@Component({
    selector: 'app-actualites',
    templateUrl: './actualites.component.html',
    styleUrls: ['./actualites.component.css']
})

export class ActualitesComponent implements OnInit {

    @Input() isRd = false
    @Input() isInterview = false

    public langSub:any
    public activeTag = null
    public page = 0
    public limit = 12
    public itemsPerPage = 12
    public posts = []
    public tags = []
    public nbPosts = 0
    public featuredPost = true
    public excludedTags = [8]


    constructor(
        protected _sanitizer: DomSanitizer,
        public newsService: NewsService,
        protected activatedRoute: ActivatedRoute,
        public language : LanguageService
    ) {
        this.langSub = this.language.langChange.subscribe(data=>{
            this.refreshActus(true);
        })
    }

    ngOnInit() {
        this.refreshActus()
        this.refreshTags()
    }

    ngOnDestroy() {
        this.langSub.unsubscribe();
    }

    refreshTags(){
        this.newsService.getTags(true)
        .then(res => {
            this.tags = res.filter(tag => tag.title != 'R&D' && tag.id != 8);
        });
    }

    refreshActus(reset = false) {
        return Promise.resolve()
        .then(()=>{
            if(this.isRd){
                return this.newsService.getPostsByTag(11, this.page, this.limit)
            }
            if(this.isInterview){
              return this.newsService.getPostsByTag(8, this.page, this.limit)
            }
            if(!this.isRd && !this.isInterview){
                if(!this.activeTag){
                    return this.newsService.getActualitesExcludingTags(this.excludedTags, this.page, this.limit);
                }
                else{
                    return this.newsService.getPostsByTag(this.activeTag, this.page, this.limit)
                }
            }
        })
        .then((res)=>{
            if(reset){
              this.posts = []
            }
            this.nbPosts = res['nbResults']
            if(res['results']){
                for(let post of res['results']){
                    if(!this.posts.find(e => Number(e['id']) == Number(post['id']))){
                        this.posts.push(post)
                    }
                }
            }
        })
    }

    selectTag(tagId){
        this.activeTag = tagId;
        this.limit = this.itemsPerPage;
        this.refreshActus(true)
    }

    showMoreActu(){
        this.limit = this.limit + this.itemsPerPage;
        this.refreshActus();
    }


}
